import { Form } from "react-router";

import type { RegisteredComponent } from "@builder.io/sdk-react";

import { useURL } from "~/contexts";

/**
 * SignOutButton — POSTs to /logout (D4: logout is an action; a GET that
 * mutates auth state is the CSRF shape P4 retired). The route renders the
 * same signed-out page and redirects home. Used inside Builder content
 * (Account Dropdown); `attributes` spread on the ROOT element per the
 * noWrap contract.
 */
const SignOutButton = ({
  attributes,
}: {
  attributes?: Record<string, unknown>;
}) => {
  const url = useURL();

  return (
    <Form {...attributes} method="post" action={url("/logout")}>
      <button
        type="submit"
        className="flex items-center gap-2 font-grotesque text-sm font-light leading-5.5 text-emphasis hover:underline"
        data-testid="sign-out-button"
      >
        Sign Out
      </button>
    </Form>
  );
};

export const SignOutButtonDefinition = {
  component: SignOutButton,
  name: "SignOutButton",
  noWrap: true,
  canHaveChildren: false,
  image: "https://unpkg.com/css.gg@2.0.0/icons/svg/log-out.svg",
  inputs: [],
} satisfies RegisteredComponent;

export default SignOutButton;
